export function fullpage_setting() {

  jQuery(function () {

    $("#anchor_project").click(function () {
      $.fn.fullpage.moveTo(4);
    });
    $("#anchor_service").click(function () {
      $.fn.fullpage.moveTo(3);
    });

    const fullpage_top = document.querySelector('#fullpage-top');
    if(fullpage_top) {
      $('#fullpage-top').fullpage({
        anchors: ['hero','label', 'service', 'project', 'partner'],
        scrollOverflow: true,
        navigation: true,
        navigationPosition: 'right',
        slidesNavigation: true,
        slidesNavPosition: 'bottom',
        controlArrows: false,
        fitToSectionDelay: '800',
        resize: true,
        //autoScrolling: false,
        normalScrollElements: '.c-modal',
        //responsiveWidth: 768,
      });
    }


    const fullpage_artist = document.querySelector('#fullpage-artist');
    if(fullpage_artist) {
      $('#fullpage-artist').fullpage({
        scrollOverflow: true,
        navigation: true,
        navigationPosition: 'right',
        slidesNavigation: true,
        slidesNavPosition: 'bottom',
        controlArrows: false,
        fitToSectionDelay: '800',
        resize: true,
        //autoScrolling: false,
        normalScrollElements: ['.c-modal', '.p-artistHero_txt'],
        //responsiveWidth: 768,
      });
    }

    const fullpage_education = document.querySelector('#fullpage-education');
    if(fullpage_education) {
      $('#fullpage-education').fullpage({
        scrollOverflow: true,
        navigation: true,
        navigationPosition: 'right',
        slidesNavigation: true,
        slidesNavPosition: 'bottom',
        controlArrows: false,
        fitToSectionDelay: '800',
        resize: true,
        //autoScrolling: false,
        normalScrollElements: '.c-modal',
        //responsiveWidth: 768,
      });
    }

    const fullpage_creative = document.querySelector('#fullpage-creative');
    if(fullpage_creative) {
      $('#fullpage-creative').fullpage({
        scrollOverflow: true,
        navigation: true,
        navigationPosition: 'right',
        slidesNavigation: true,
        slidesNavPosition: 'bottom',
        controlArrows: false,
        fitToSectionDelay: '800',
        resize: true,
        //autoScrolling: false,
        normalScrollElements: '.c-modal',
        //responsiveWidth: 768,
      });
    }
    
  });

}